// Separate so tests can mock it: jsdom can't stub location.reload.
export function reloadPage() {
  window.location.reload();
}
